<template>
  <DialogTemplateToolkit
    v-if="$acl.check('onlyTenders')"
    class-name="valid-tender-copy"
    :dialog="showModal"
    :disabled="load_bids"
    :first_btn="copy_offers != 'SELECTED' ? 'Tenders.Continue' : ''"
    :loading="loading"
    :second_btn="blockCopy ? 'Common.Close' : ''"
    :title="$t('Purchasing.Repeat')"
    :without_first_btn="blockCopy && copy_offers === 'SELECTED'"
    @apply="submitBidType"
    @close="close">
    <template #activator-btn>
      <CopyItem
        :copy-item="copyItem"
        :disabled="load_bids"
        :list="list"/>
    </template>
    <template #card-text>
      <sForm
        ref="valid-tender-copy-form"
        :disabled="loading"
        label-position="top"
        :model="{biddingType, organisation}"
        :rules="rules">
        <template v-if="can_choose_org">
          <div class="valid-tender-copy__title pa-0 pb-3 h2-headline">
            {{ $t('Tenders.SpecifyOrganizationToRepeatTender') }}
          </div>
          <div class="valid-tender-copy__text pa-0 ma-0 h6-text">
            {{ $t('Tenders.SpecifyOrganizationToRepeatTenderText') }}
          </div>
          <sFormItem
            v-if="can_choose_org"
            ref="template-organisation"
            class="mt-4 input"
            :label="$t('Tenders.TenderOrganizer')"
            prop="organisation.organizationItId">
            <OrgsList
              data-qa="select-organization"
              :disabled="loading || load_bids"
              :model.sync="organisation"
              :multiple="false"
              @change="changeOrg"/>
          </sFormItem>
        </template>
        <template
          v-if="wrong_bidType">
          <div :class="['valid-tender-copy__title pa-0 pb-3 h2-headline', {'pt-4': can_choose_org }]">
            {{ can_choose_org && organisation ? $t('Tenders.TenderTypeNotAvailableForCopyingInOrg') : $t('Tenders.TenderTypeNotAvailableForCopying') }}
          </div>
          <div class="valid-tender-copy__text pa-0 ma-0 h6-text">
            {{ can_choose_org && organisation ? $t('Tenders.TenderTypeNotAvailableForCopyingTextInOrg', {org: organisation.title}) : $t('Tenders.TenderTypeNotAvailableForCopyingText') }}
          </div>
          <sAlert
            v-if="showGroupLotAlert"
            class="mt-2"
            data-qa="copyAlertWrongType"
            small
            type="warning">
            {{ $t('Tenders.NewBiddingTypeNotAvailableLotGroups') }}
          </sAlert>
          <sFormItem
            ref="template-type"
            class="mt-4 input"
            :label="$t('Tenders.TenderType')"
            prop="biddingType.biddingTypeId">
            <sSelect
              class="valid-tender-copy__choose-type input"
              data-qa="biddingType"
              :disabled="loading || load_bids"
              filterable
              :loading="load_bids"
              :placeholder="$t('Tenders.TenderType')"
              :value.sync="biddingType"
              value-key="biddingTypeId">
              <sOption
                v-for="item in bidding_types"
                :key="`bidding-types-${item.biddingTypeId}`"
                :data-qa="`biddingType-item-${item.biddingTypeId}`"
                :label="item.titleRu"
                :value="item"/>
            </sSelect>
          </sFormItem>
        </template>
        <CopyOffersSection
          v-if="can_select_bids"
          :attachments_required="$_mustCopyAttachments"
          :block_copy="blockCopy"
          :copy_offers.sync="copy_offers"
          :copy_offers_files.sync="copy_offers_files"
          :disabled="loading"
          :not_possible_message="$t('Tenders.CopyNotPossible')"
          :text="$t('Tenders.CopyBidsToANewTenderText')"
          :title="$t('Tenders.CopyBidsToANewTender')"
          :title_class="{'pt-4': wrong_bidType }"/>
      </sForm>
    </template>
    <template
      v-if="copy_offers === 'SELECTED' && !blockCopy"
      #first_btn>
      <SelectOffersForCopy
        :copy-tender="copyTender"
        :copy_offers_files="copy_offers_files"
        :disabled="loading"
        :loading="loading"
        :tender="tender"
        :validate="validate"/>
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import CopyItem from 'components/common/elements/CopyItem.vue'
import OrgsList from 'components/common/elements/OrgsList.vue'
import SelectOffersForCopy from 'pages/tender creation/SelectOffersForCopy.vue'
import CopyOffersSection from 'components/tenders/dialogs/CopyOffersSection.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { mapGetters } from 'vuex'
import { userMixin, copyTenderMixin } from 'mixins'
import SmarttenderApi from '@/api/smarttenderApi'

const st_api = new SmarttenderApi()

export default {
  name: 'copyTender',
  mixins: [userMixin, copyTenderMixin],
  data() {
    const that = this
    return {
      loading: false,
      load_bids: false,
      showModal: false,
      bidding_types: [],
      cur_bidding_types: [],
      biddingType: {},
      organisation: {},
      rules: {
        'biddingType.biddingTypeId': {
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (that.wrong_bidType && !value ) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
        'organisation.organizationItId': {
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (that.can_choose_org && !value ) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
      }
    }
  },
  props: {
    tender: Object,
    withoutBid: Boolean,
    list: Boolean
  },
  created() {
    this.load_bids = true
    this.checkFormula()
    this.$store.dispatch('setBiddingTypes')
      .then(res => {
        let frame = this.tender.biddingType ? this.tender.biddingType?.isFrameAuction : res.find(type => type.biddingTypeId == this.tender.biddingTypeId)?.isFrameAuction
        if ( !frame ) {
          res = res.filter(el => !el.isFrameAuction )
        }
        this.bidding_types = res
        this.cur_bidding_types = res
      })
      .finally(() => this.load_bids = false)
    this.setDefaultOrg()
  },
  computed: {
    ...mapGetters({
      availableOrganizations: 'getAvailableOrganizations',
      cur_organisation: 'getCurrentOrganization',
    }),
    showGroupLotAlert() {
      return this.wrong_bidType && this.biddingType?.biddingTypeId && !!this.tender?.lotGroups?.length && !this.biddingType.groupedLotsEnabled
    },
    wrong_bidType() {
      return !this.bidding_types?.some(type => type?.biddingTypeId == (this.tender.biddingType?.biddingTypeId || this.tender.biddingTypeId ))
    },
    can_choose_org() {
      return this.availableOrganizations?.length > 1
    },
    can_select_bids() {
      if (this.withoutBid) {
        return false
      }

      if (!this.tender.bids?.length) {
        return false
      }
      
      if (this.tender.biddingType?.dontCopySuppliers) {
        return false
      }
      
      const status = this.tender?.tenderStatus?.id || this.tender?.tenderStatusId
      return [this.statuseKeys.BID_ANALYSIS, this.statuseKeys.COMPLETED].includes(status) && this.$can('copy', 'bids')
    },
  },
  methods: {
    close() {
      this.showModal = false
      this.biddingType = {}
      this.setDefaultOrg()
    },
    changeOrg(org) {
      if (org) {
        this.load_bids = true
        this.biddingType = {}
        this.$store.dispatch('setBiddingTypes', { org: org.organizationItId })
          .then(res => {
            this.bidding_types = res
          })
          .finally(() => {
            this.load_bids = false
          })
      } else {
        this.setDefaultOrg()
        this.bidding_types = this.$_.cloneDeep(this.cur_bidding_types)
      }
    },
    setDefaultOrg() {
      this.organisation = this.$_.cloneDeep(this.cur_organisation)
    },
    copyItem() {
      if (this.list) {
        this.$root.$emit('closeSnackbar')
      }
      
      if (this.wrong_bidType || this.can_choose_org || this.can_select_bids) {
        setTimeout(() => {
          this.showModal = true
        }, 100)
      } else {
        this.copyTender()
      }
    },
    async validate() {
      return await this.$refs['valid-tender-copy-form'].validate()
    },
    submitBidType() {
      if (this.blockCopy) {
        return
      }
      this.$refs['valid-tender-copy-form'].validate()
        .then(() => this.copyTender())
    },
    async copyTender(bids = []) {
      this.loading = true
      this.$root.$emit('showOverlay')
      
      const tender = this.$_.cloneDeep(this.tender)

      // Подготовка предложений для копирования если выбрано "копировать все"
      bids = await this.$_resolveBidsForCopy(tender, bids)

      // Формирование модели для API запроса
      const biddingTypeId = this.biddingType?.biddingTypeId || tender.biddingTypeId || tender.biddingType?.biddingTypeId
      const organizationItId = this.organisation.organizationItId
      const selected_bids = this.$_mapBidsToCopyModel(bids)

      const model = {
        tenderId: tender.tenderId,
        biddingTypeId,
        organizationItId,
        bids: selected_bids
      }
      try {
        const newTenderId = await st_api.copyTender(model)
        
        if (!newTenderId) {
          throw this.$t('Common.ErrorTitle')
        }
        
        this.showModal = false
        
        // Смена организации если необходимо
        if (organizationItId && this.$route.params.org !== organizationItId) {
          await this.changeOrganisation(
            { organizationItId },
            { organizationItId: this.$route.params.org },
            false
          )
        }
        
        // Переход к редактированию скопированного тендера
        this.$nextTick(() => {
          this.$store.commit('setNewTenderInfo', { mode: 'edit', step: 1 })
          this.$router.push({
            name: 'editTender',
            query: { step: 1, id: newTenderId },
            params: { org: organizationItId }
          })
        })
      } catch (error) {
        this.$notice.error({
          title: this.$t('Common.ErrorTitle'),
          message: this.$_getCopyErrorMessage(error),
          duration: 10,
        })
        this.$store.commit('setNewTenderInfo', {})
        this.$store.commit('setDefaultTender')
        this.$log_error(error)
      } finally {
        this.loading = false
        this.$root.$emit('closeOverlay')
      }
    },
  },
  components: {
    CopyItem,
    OrgsList,
    SelectOffersForCopy,
    CopyOffersSection,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.valid-tender-copy {
  .h2-headline {
    line-height: 28px !important;
  }
  .input  {
    width: 400px;
  }
}
</style>
